/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingGovIcon16Regular = forwardRef('BuildingGovIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.61 2.546a2.25 2.25 0 0 1 2.78 0l5.147 4.044a.75.75 0 0 0 .926-1.18l-5.146-4.043a3.75 3.75 0 0 0-4.634 0L.537 5.41a.75.75 0 1 0 .926 1.18L6.61 2.546Z" }),
        React.createElement("path", { d: "M4 6.25a.75.75 0 0 1 .75.75v4.25a.75.75 0 0 1-1.5 0V7A.75.75 0 0 1 4 6.25Z" }),
        React.createElement("path", { d: "M.75 14a.75.75 0 0 1 .75-.75h13a.75.75 0 0 1 0 1.5h-13A.75.75 0 0 1 .75 14Z" }),
        React.createElement("path", { d: "M8.75 7a.75.75 0 1 0-1.5 0v4.25a.75.75 0 0 0 1.5 0V7Z" }),
        React.createElement("path", { d: "M12 6.25a.75.75 0 0 1 .75.75v4.25a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75Z" })));
});
